export default __webpack_public_path__ + "static/050_te_loomis_2828.png";